import {themeGetter} from 'quickstart/system'

const getCards = (theme: any) => {
  const th = themeGetter(theme)
  return {
    default: {
      card: {
        backgroundColor: th('colors.backgroundColorWhite'),
        borderRadius: th('radii.none'),
        borderStyle: 'solid',
        borderWidth: 0,
        borderColor: th('colors.borderColor'),
        boxShadow: th('shadows.v2'),
        // Following work with conditional stretch in styles.js
        display: 'flex',
        flexDirection: 'column',
        ...th('hovers.raise'),
      },
      cover: {
        borderTopLeftRadius: th('radii.none'),
        borderTopRightRadius: th('radii.none'),
      },
      body: {
        borderTopColor: th('colors.borderColor'),
        borderTopStyle: 'solid',
        borderTopWidth: th('borderWidths.sm'),
        padding: th('space.xl'),
      },
      footer: {
        paddingLeft: th('space.xl'),
        paddingRight: th('space.xl'),
        paddingTop: 0,
        paddingBottom: th('space.xl'),
      },
      meta: {
        ...th('prose.cardMeta'),
        color: th('colors.textColorMuted'),
      },
      heading: {
        ...th('fonts.heading'),
        ...th('prose.cardHead'),
      },
      description: {
        ...th('fonts.body'),
        ...th('ui.cardSnippet'),
      },
      callToAction: {
        ...th('ui.cardCta'),
        color: th('colors.linkColor'),
      },
    },
  }
}

export default getCards
